import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {SortUtils} from '../../../shared/utils/sort-utils';
import {Observable} from 'rxjs';
import {DemandPartner} from '../../../shared/domain/demand-partner.model';
import {AdStatsDemandPartnersService} from '../../../shared/services/ad-stats-demand-partners.service';

@Component({
  selector: 'cm-demand-partner-autocomplete',
  template: `
    <mat-form-field [floatLabel]="floatLabel || 'always'" class="w-100">
      <input matInput placeholder="{{placeholder || 'Demand Partner'}}"
             aria-label="Ad unit"
             [matAutocomplete]="auto"
             [formControl]="filterCtrl">
      <mat-autocomplete #auto="matAutocomplete"
                        (optionSelected)="optionSelected($event)"
                        [displayWith]="display">
        <mat-option *ngFor="let dp of filteredItems | async" [value]="dp">
          <cm-activity-status-circle class="mr-1" [status]="dp.activityStatus"></cm-activity-status-circle>
          {{dp.displayName}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  `,
})
export class DemandPartnerAutocompleteComponent implements OnInit {

  @Input()
  placeholder: string;

  @Input()
  floatLabel: string;

  @Output()
  itemSelected = new EventEmitter<DemandPartner>();

  @Output()
  demandPartnerListAcquired = new EventEmitter<DemandPartner[]>();

  items: DemandPartner[] = [];
  filteredItems: Observable<DemandPartner[]>;
  filterCtrl = new FormControl();
  selectedItem;

  constructor(private service: AdStatsDemandPartnersService) {
    this.filteredItems = this.filterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(item => {
          if (typeof item !== 'object') {
            return this.items.filter(p => p.displayName.toLowerCase().includes(item.toLowerCase())).slice(0, 5);
          } else {
            return this.items.slice(0, 5);
          }
        })
      );
    this.filterCtrl.valueChanges.subscribe(next => {
      if (!next && this.selectedItem) {
        this.selectedItem = undefined;
        this.emit();
      }
    });
  }


  ngOnInit(): void {
    this.service.demandPartners().subscribe(next => {
      this.items = next;
      this.items.sort(SortUtils.propertyComparatorString('displayName'));
      this.demandPartnerListAcquired.emit(this.items);
    });
  }

  display(p?: DemandPartner) {
    return p ? p.displayName : undefined;
  }

  optionSelected($event) {
    this.selectedItem = $event.option.value;
    this.emit();
  }

  resetInput() {
    this.selectedItem = null;
    this.filterCtrl.setValue(null);
  }

  private emit() {
    this.itemSelected.emit(this.selectedItem);
  }
}
